import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionService } from '../_services/permission.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate, CanActivateChild {
  private logicalOp = "AND";
  constructor(
    private router: Router,
    private permissionService: PermissionService
  ) { }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const permissions = route.data.permissions as string[]
    return this.permissionService.checkPermission(permissions, this.logicalOp)
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const permissions = route.data.permissions as string[]
    return this.permissionService.checkPermission(permissions, this.logicalOp)
  }

}
